import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';

const STORAGE_KEY = 'daniele_age_verified_v1';

const AgeGate = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    try {
      const verified = localStorage.getItem(STORAGE_KEY);
      if (!verified) setVisible(true);
      setChecked(true);
    } catch (e) {
      setVisible(true);
      setChecked(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        verified: true,
        timestamp: new Date().toISOString(),
      }));
    } catch (e) { /* ignore */ }
    setVisible(false);
  };

  const decline = () => {
    // Redirect minori via
    window.location.href = 'https://www.google.com';
  };

  if (!checked || !visible) return null;

  return (
    <div className="age-gate-overlay" role="dialog" aria-modal="true" data-testid="age-gate">
      <div className="age-gate-modal">
        <div className="age-gate-inner">
          <ShieldCheck size={48} className="age-gate-icon" />
          <h1 className="age-gate-title">{t('ageGate.title')}</h1>
          <p className="age-gate-warning">{t('ageGate.warning')}</p>
          <p className="age-gate-question">{t('ageGate.question')}</p>

          <div className="age-gate-actions">
            <button
              type="button"
              className="age-gate-btn age-gate-btn-decline"
              onClick={decline}
              data-testid="age-gate-decline"
            >
              {t('ageGate.no')}
            </button>
            <button
              type="button"
              className="age-gate-btn age-gate-btn-accept"
              onClick={accept}
              data-testid="age-gate-accept"
            >
              {t('ageGate.yes')}
            </button>
          </div>

          <p className="age-gate-note">{t('ageGate.note')}</p>
        </div>
      </div>
    </div>
  );
};

export default AgeGate;
